//import './_dev/style.css'; // Remove this on build, only for dev
import './css/style.css'; // For react booking

import { createRoot } from "react-dom/client";
import {BrowserRouter, Routes, Route, useParams} from "react-router-dom";
import Layout from "./pages/Layout";
import Container from "./pages/Container";
import HjulskifteUpdate from "./pages/HjulskifteUpdate";
import Index from "./pages/Index";

const baseUrl = window.react_data.app_url ? window.react_data.app_url : '/';
const root = createRoot(document.getElementById("react_booking"));

root.render(
    <BrowserRouter basename={baseUrl}>
        <Routes>
            <Route path="/" element={<Layout/>}>
                <Route index element={<Index/>}/>
                <Route path="/:slug/:id" element={<Container/>}/>
                <Route path="/:slug" element={<Container/>}/>
                <Route path="/andra-tid-hjulskifte" element={<HjulskifteUpdate/>}/>
                <Route path="/andra-tid-hjulskifte/:order_key" element={<HjulskifteUpdate/>}/>
                <Route path="/andra-tid-hjulskifte/:order_key/:user_id" element={<HjulskifteUpdate/>}/>
            </Route>
        </Routes>
    </BrowserRouter>
)
